'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OauthToken = exports.SecurityEvents = undefined;
exports.registerEventHandlers = registerEventHandlers;
exports.createOauthAPIClient = createOauthAPIClient;

var _Storage = require('../Storage');

var _EventHandler = require('../Core/EventHandler');

var _events = require('./events');

var SecurityEvents = _interopRequireWildcard(_events);

var _OauthFacade = require('./OauthFacade');

var _OauthFacade2 = _interopRequireDefault(_OauthFacade);

var _OauthToken = require('./OauthToken');

var _OauthToken2 = _interopRequireDefault(_OauthToken);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.SecurityEvents = SecurityEvents;
exports.OauthToken = _OauthToken2.default;

/**
 * Registers the Security events with the event dispatching system
 *
 * @function
 *
 * @param {WidgetWindowBridge} windowBridge
 * @param {AppClient} app
 */
/**
 * This module exports the interface of the Security package
 *
 * @module Security
 */

function registerEventHandlers(windowBridge, app) {
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, SecurityEvents.EVENT_SECURITY_AUTHENTICATE_OAUTH, SecurityEvents.props.EVENT_SECURITY_AUTHENTICATE_OAUTH);
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, SecurityEvents.EVENT_SECURITY_SETTINGS_OAUTH, SecurityEvents.props.EVENT_SECURITY_SETTINGS_OAUTH);
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, SecurityEvents.EVENT_SECURITY_OAUTH_REFRESH, SecurityEvents.props.EVENT_SECURITY_OAUTH_REFRESH);
}

/**
 * @function
 *
 * @param {AppEventEmitter} outgoingDispatcher
 * @param {AppEventEmitter} internalDispatcher
 * @param {InstanceProps} instanceProps
 * @param {ContextProps} contextProps
 * @return {OauthFacade}
 */
function createOauthAPIClient(outgoingDispatcher, internalDispatcher, instanceProps, contextProps) {
  var storageClient = (0, _Storage.createStorageAPIClient)(outgoingDispatcher, internalDispatcher, instanceProps, contextProps);
  var setStorage = storageClient.setAppStorage.bind(storageClient);

  return new _OauthFacade2.default(outgoingDispatcher, setStorage);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Security/index.js
// module id = 102
// module chunks = 0